import classNames from 'classnames';
import IconStar from 'components/Generic/Icons/IconStar';

type RatingProps = {
  rating: number;
  className?: string;
};

const Rating = ({ rating = 5, className }: RatingProps) => {
  const getFillPercent = (starNumber: number): number => {
    if (rating >= starNumber) {
      return 100;
    } else {
      const floatingValue: number = Number((rating % 1).toFixed(1));
      if (rating > starNumber - 1) {
        return floatingValue * 100;
      }
      return 0;
    }
  };

  return (
    <div className={classNames('rating background-to-change', className)}>
      {[...Array(5)].map((_star, index) => (
        <IconStar key={index} fillingPercentage={getFillPercent(index + 1)} />
      ))}
    </div>
  );
};

export default Rating;
